// Shared labels/helpers for the subscription admin modules (Features 3–14).
// Plain exports (no reactivity) so any view/store can reuse them — keeps the
// Arabic label maps and error handling in one place.

export const PLAN_TYPES = ['monthly', 'term1', 'term2', 'yearly'];

export const PLAN_LABELS = {
    monthly: 'شهري',
    term1: 'الترم الأول',
    term2: 'الترم الثاني',
    yearly: 'سنوي',
    // Courses: one-time purchase, permanent access (no expiry).
    lifetime: 'مدى الحياة',
};

export const STATUS_LABELS = {
    pending: 'بانتظار الدفع',
    waiting_payment: 'مراجعة الدفع',
    active: 'مفعّل',
    expired: 'منتهي',
    cancelled: 'ملغي',
};

export const REQUEST_STATUS_LABELS = {
    pending: 'قيد المراجعة',
    approved: 'مقبول',
    rejected: 'مرفوض',
};

export const TYPE_LABELS = {
    academic_year: 'سنة دراسية',
    course: 'كورس',
    AcademicYear: 'سنة دراسية',
    Course: 'كورس',
};

export function planLabel(type) { return PLAN_LABELS[type] ?? type; }
export function statusLabel(s) { return STATUS_LABELS[s] ?? s; }
export function requestStatusLabel(s) { return REQUEST_STATUS_LABELS[s] ?? s; }

// Design-system status-badge tone (reuses the shared .status-badge--* classes
// from design-system.css so every page's badges share one color language).
const STATUS_TONE = {
    pending: 'pending',
    waiting_payment: 'waiting',
    active: 'accepted',
    expired: 'rejected',
    cancelled: 'blocked',
};
const REQUEST_STATUS_TONE = {
    pending: 'pending',
    approved: 'accepted',
    rejected: 'rejected',
};
export function statusTone(s) { return `status-badge--${STATUS_TONE[s] ?? 'blocked'}`; }
export function requestStatusTone(s) { return `status-badge--${REQUEST_STATUS_TONE[s] ?? 'blocked'}`; }

// Normalizes a subscribable_type ("App\\Models\\Course") or short alias to Arabic.
export function typeLabel(type) {
    if (!type) return '';
    const base = String(type).split('\\').pop();
    return TYPE_LABELS[base] ?? base;
}

export function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    return n.toLocaleString('en-EG') + ' ج';
}

export function formatDate(value) {
    if (!value) return '—';
    const d = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' });
}

// Pull the best human message out of an axios error (matches backend envelope).
export function apiError(error, fallback = 'حدث خطأ، حاول مرة أخرى') {
    return error?.response?.data?.message || fallback;
}
